import { useState, useEffect } from "react";
import CfLoader from "../CfLoader/CfLoader";

export const DocumentPreview = ({ documentUrl }) => {
  const [loading, setLoading] = useState(true);
  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
    if (documentUrl) {
      const isPdfFile =
        documentUrl.toLowerCase().endsWith(".pdf") ||
        documentUrl.includes("content-type=application%2Fpdf") ||
        (documentUrl.includes("amazonaws.com") &&
          (documentUrl.includes(".pdf") ||
            documentUrl.includes("application/pdf")));
      setIsPdf(isPdfFile);
    }
  }, [documentUrl]);

  if (!documentUrl) {
    return (
      <div className="flex flex-col flex-shrink max-h-[78vh] justify-center items-center">
        <CfLoader />
      </div>
    );
  }

  if (isPdf) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        {loading && (
          <div className="absolute">
            <CfLoader />
          </div>
        )}
        <iframe
          src={documentUrl}
          className="w-full h-[78vh] border-0"
          title="PDF Preview"
          onLoad={() => setLoading(false)}
          onError={() => setLoading(false)}
        />
      </div>
    );
  }

  return (
    <img
      className="flex flex-col flex-shrink max-h-[78vh]"
      src={documentUrl}
      alt="Verification Document"
      onLoad={() => setLoading(false)}
      onError={() => setLoading(false)}
    />
  );
};
